import React from "react";
import ReactDOM from "react-dom";
import { observer } from "mobx-react";
import { Route, Router, Switch } from "react-router-dom";
import { myHistory } from "./common/History";
import { ApolloProvider } from "@apollo/react-hooks";
import "./common/Aws";

import { App } from "./App";
import { Login } from "./pages/auth/Login";
import { Forgot } from "./pages/auth/Forgot";
import { Reset } from "./pages/auth/Reset";
import * as serviceWorker from "./serviceWorker";

import { Auth } from "aws-amplify";
import { client } from "./graphql/client";
import { AppProvider } from "./components/AppProvider";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { VolunteerPresent } from "./pages/volunteer/VolunteerPresent";

const queryClient = new QueryClient();

Auth.currentAuthenticatedUser({
  bypassCache: true,
})
  .then((user) => {
    Auth.userAttributes(user)
      .then((res) => {})
      .catch((err) => {
        console.log("dd", err);
        if (err.code === '"PasswordResetRequiredException"') {
          myHistory.push("/reset");
        }
      });
  })
  .catch((err) => console.log("ss", err));

Auth.currentSession()
  .then((res) => {
    console.log("dd", res);
    if (!res.isValid()) {
      const { pathname = "" } = myHistory.location;
      if (
        !pathname.startsWith("/login") &&
        !pathname.startsWith("/forgot") &&
        !pathname.startsWith("/reset") &&
        !pathname.startsWith("/volunteer-present")
      ) {
        myHistory.push("/login");
      }
    }
  })
  .catch((err) => {
    console.log("dd", err);
    const { pathname = "" } = myHistory.location;
    if (
      !pathname.startsWith("/login") &&
      !pathname.startsWith("/forgot") &&
      !pathname.startsWith("/reset") &&
      !pathname.startsWith("/volunteer-present")
    ) {
      myHistory.push("/login");
    }
  });

const MyRouter = observer(() => (
  <Router history={myHistory}>
    <AppProvider>
      <ApolloProvider client={client}>
        <QueryClientProvider client={queryClient}>
          <Switch>
            <Route path="/volunteer-present/:id" exact component={VolunteerPresent} />
            <Route path="/login" exact component={Login} />
            <Route path="/forgot" exact component={Forgot} />
            <Route path="/reset" exact component={Reset} />
            <Route path="/" component={App} />
          </Switch>
        </QueryClientProvider>
      </ApolloProvider>
    </AppProvider>
  </Router>
));

ReactDOM.render(<MyRouter />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
